import { create } from 'zustand';

import { toPlayerMessage } from '@/shared/api';
import { isFresh, singleFlight } from '@/shared/lib';

import { fetchFreebetsStatus } from '../api/freebets.api';

import type { FreebetsStatus } from './types';

/**
 * Заявка на Фрибеты.
 *
 * Счётчик за цикл дублируется в сводке игрока — его показывает шапка.
 * Этот срез нужен ради остального: статуса заявки, права нажать
 * «Получить» и срока, до которого это право живёт.
 */
interface FreebetsState {
  status: FreebetsStatus | null;
  isLoading: boolean;
  error: string | null;
  loadedAt: number | null;

  load: (options?: { force?: boolean }) => Promise<void>;
  reset: () => void;
}

export const useFreebetsStore = create<FreebetsState>()((set, get) => ({
  status: null,
  isLoading: false,
  error: null,
  loadedAt: null,

  load: singleFlight(async (options?: { force?: boolean }): Promise<void> => {
    if (!options?.force && isFresh(get().loadedAt)) return;

    set({ isLoading: true, error: null });
    try {
      set({ status: await fetchFreebetsStatus(), loadedAt: Date.now() });
    } catch (error) {
      set({ error: toPlayerMessage(error) });
    } finally {
      set({ isLoading: false });
    }
  }),

  reset: () => {
    set({ status: null, error: null, loadedAt: null });
  },
}));
